import type { ChartType, Plugin } from 'chart.js';

export function createChartRenderCompletePlugin<TType extends ChartType>(
  onRendered: () => void,
): Plugin<TType> {
  let notified = false;

  return {
    id: 'chartRenderComplete',
    afterDraw() {
      if (notified) {
        return;
      }

      notified = true;
      onRendered();
    },
  };
}
